import { ShieldCheck, Landmark, Lock, Download, AlertTriangle } from "lucide-react";
import { useLang } from "@/lib/i18n";

export const HowItWorks = () => {
  const { t } = useLang();
  const steps = t("how.steps");
  return (
    <section className="container-z py-20" aria-labelledby="how-title" data-testid="how-section">
      <p className="eyebrow">{t("how.eyebrow")}</p>
      <h2 id="how-title" className="font-hi mt-3 max-w-3xl text-3xl font-bold tracking-tight sm:text-4xl">{t("how.title")}</h2>
      <ol className="mt-12 grid border-l border-t border-navy/10 sm:grid-cols-2 lg:grid-cols-5">
        {steps.map(([title, desc], i) => (
          <li key={title} className="border-b border-r border-navy/10 bg-white/50 p-6" data-testid={`how-step-${i + 1}`}>
            <span className="text-4xl font-bold text-cyan">{String(i + 1).padStart(2, "0")}</span>
            <h3 className="mt-6 text-base font-semibold">{title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-navy/65">{desc}</p>
          </li>
        ))}
      </ol>
    </section>
  );
};

const ICONS = [ShieldCheck, Landmark, Lock, Download];

export const Trust = () => {
  const { t } = useLang();
  return (
    <section className="bg-navy py-20 text-white" aria-labelledby="trust-title" data-testid="trust-section">
      <div className="container-z grid gap-12 lg:grid-cols-[1fr_1.4fr]">
        <div>
          <p className="eyebrow !text-cyan">{t("trust.eyebrow")}</p>
          <h2 id="trust-title" className="mt-3 text-3xl font-bold tracking-tight sm:text-4xl">{t("trust.title")}</h2>
          <p className="mt-6 flex items-start gap-3 rounded-2xl bg-white/5 p-5 text-sm leading-relaxed text-white/80" data-testid="trust-otp-warning">
            <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-amber-300" />{t("trust.warn")}
          </p>
        </div>
        <div className="grid gap-5 sm:grid-cols-2">
          {t("trust.items").map(([title, desc], i) => {
            const Icon = ICONS[i];
            return (
              <div key={title} className="rounded-2xl border border-white/10 bg-white/[0.03] p-6">
                <Icon className="h-6 w-6 text-cyan" />
                <h3 className="mt-4 font-semibold">{title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-white/70">{desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
